import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FaqContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getFaq(id: string): Observable<any> {
    return this.getFaqContents(id).pipe(
      map(res =>
        this.mapFaq(this.extractResult(res))
      ),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryFaqContents[0].flatData;
  }

  private getFaqContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryFaqContents(filter: "id eq '${id}'") {
          flatData {
            categoria
            title
            conteudo {
              titulo
              descricao
              documentos {
                flatData {
                  name
                  documents {
                    title
                    file {
                      url
                    }
                  }
                }
              }
              components {
                __typename
                ... on Accordion {
                  flatData {
                    name
                    questions {
                      title
                      description
                    }
                  }
                }
                ... on TabelasDinamicas {
                  flatData {
                    header
                    textAfter
                    textBefore
                    data {
                      flatData {
                        name
                        content
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private mapFaq(response) {
    const content = response.conteudo.map(data => {
      let documents = [];
      if (data.documentos && data.documentos.length > 0) {
        documents = data.documentos[0].flatData.documents.map(item => {
          return {
            title: item.title,
            link: item.file[0].url
          };
        });
      }
      let components = [];
      if (data.components && data.components.length > 0) {
        components = data.components;
      }
      return {
        title: data.titulo,
        description: data.descricao,
        documents,
        components
      };
    });
    return  {
      title: response.title,
      content
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
